const SET_RESEARCHERS = (state, users) => {
  state.researchers = users
}

const SET_FUNDERS_BY_PROTOCOL = (state, payload) => {
  const {
          protocol,
          funders,
        } = payload
  
  state.fundersByProtocol[protocol.id] = funders
}

const SET_SELECTED_PROTOCOL = (state, protocol) => {
  state.selectedProtocol = protocol
}

const SET_PROTOCOL_RESEARCHERS = (state, researchers) => {
  state.researchers = researchers
  state.selectedProtocol.researchers = researchers
}

const SET_PROTOCOL_EXTERNAL_RESEARCHERS = (state, externalResearchers) => {
  state.externalResearchers = externalResearchers
  state.selectedProtocol.externalResearchers = externalResearchers
}

const SET_PROTOCOL_FILE = (state, file) => {
  state.selectedProtocol = {
    ...state.selectedProtocol,
    file: file,
  }
}

const SET_AMENDMENT_FILE = (state, file) => {
  state.selectedProtocol = {
    ...state.selectedProtocol,
    amendment_file: file,
  }
}

const SET_PROTOCOL_ATTACHMENTS = (state, files) => {
  state.selectedProtocol = {
    ...state.selectedProtocol,
    attachments: files,
  }
}

const SET_PROTOCOL_FUNDERS = (state, funders) => {
  state.funders = funders
  
  state.selectedProtocol = {
    ...state.selectedProtocol,
    funders,
  }
}

const UPDATE_PROTOCOL_FUNDERS = (state, funders) => {
  state.funders = [...funders]
  
  state.selectedProtocol = {
    ...state.selectedProtocol,
    funders,
  }
}

const SET_RESEARCH_LINES = (state, lines) => {
  state.researchLines = lines
}

const SET_PROTOCOL_RESEARCH_LINES = (state, lines) => {
  state.selectedProtocol.research_lines = lines
}

const SET_PROTOCOL_PRIMARY_RESEARCH_LINE = (state, line) => {
  state.selectedProtocol.primary_line = line
}

const SET_PROTOCOL_SECONDARY_RESEARCH_LINE = (state, line) => {
  state.selectedProtocol.secondary_line = line
}

const UPDATE_PROTOCOL_DEVELOPMENT_REQUEST = (state, development) => {
  state.selectedProtocol.development_request = development
}

const UPDATE_FINANCING_COMMITMENTS = (state, financingCommitments) => {
  state.financingCommitments = [...financingCommitments]
}

const ADD_FINANCING_COMMITMENT = (state, commitment) => {
  state.financingCommitments.push(commitment)
}

const UPDATE_PROTOCOL_RESEARCHERS = (state, researchers) => {
  state.researchers = [...researchers]
}

const SET_PROTOCOL_FINANCING_INFORMATION = (state, financingInformation) => {
  state.selectedProtocol = {
    ...state.selectedProtocol,
    financing_information: financingInformation,
    has_financing_information: financingInformation.has_financing,
  }
}

const SET_BIOSECURITY_QUESTIONNAIRE = (state, questionnaire) => {
  state.biosecurityQuestionnaire = questionnaire ? questionnaire : {}
  
  state.selectedProtocol = {
    ...state.selectedProtocol,
    biosecurityQuestionnaire: questionnaire,
    biosecurity_questionnaire: questionnaire,
  }
}

const SET_READONLY =(state, value) => {
  state.readonly = value
}

const SET_RPBI_RESEARCHERS =(state, researchers) => {
  state.rpbiResearchers = researchers
}

const SET_ETHICS_RENEWAL_ATTACHMENTS = (state, files) => {
  state.renewalAttachments = files
}

const SET_MOTHER_PROTOCOL = (state, files) => {
  state.motherProtocol = files
}

const APPEND_ETHICS_RENEWAL_ATTACHMENTS = (state, files) => {
  state.renewalAttachments = [...state.renewalAttachments, ...files]
}

export default {
  SET_RESEARCHERS,
  SET_FUNDERS_BY_PROTOCOL,
  SET_SELECTED_PROTOCOL,
  SET_PROTOCOL_RESEARCHERS,
  SET_PROTOCOL_EXTERNAL_RESEARCHERS,
  SET_PROTOCOL_FILE,
  SET_AMENDMENT_FILE,
  SET_PROTOCOL_ATTACHMENTS,
  SET_PROTOCOL_FUNDERS,
  UPDATE_PROTOCOL_FUNDERS,
  SET_RESEARCH_LINES,
  SET_PROTOCOL_RESEARCH_LINES,
  SET_PROTOCOL_PRIMARY_RESEARCH_LINE,
  SET_PROTOCOL_SECONDARY_RESEARCH_LINE,
  UPDATE_FINANCING_COMMITMENTS,
  ADD_FINANCING_COMMITMENT,
  UPDATE_PROTOCOL_DEVELOPMENT_REQUEST,
  UPDATE_PROTOCOL_RESEARCHERS,
  SET_PROTOCOL_FINANCING_INFORMATION,
  SET_BIOSECURITY_QUESTIONNAIRE,
  SET_READONLY,
  SET_RPBI_RESEARCHERS,
  SET_ETHICS_RENEWAL_ATTACHMENTS,
  SET_MOTHER_PROTOCOL,
  APPEND_ETHICS_RENEWAL_ATTACHMENTS,
}
